import type { Locale } from 'date-fns';
import { enUS, ja, ko, zhCN, zhTW } from 'date-fns/locale';
import { Linktrainrelaymixer } from '@linktivity/eticketportal';

/**
 * Maps i18n language code to date-fns Locale object
 */
export function getDateFnsLocale(language: string): Locale {
  const localeMap: Record<string, Locale> = {
    en: enUS,
    ja,
    ko,
    zh: zhCN,
    zt: zhTW
  };

  return localeMap[language] || zhCN;
}

type OrderLocaleLanguage =
  Linktrainrelaymixer.GetOrderDetailsCommonLocaleLanguageEnum;
const OrderLocaleLanguage =
  Linktrainrelaymixer.GetOrderDetailsCommonLocaleLanguageEnum;

/**
 * Maps the i18n language code to the SDK's `common.locale.language` enum used by
 * the linktrainrelaymixer order APIs.
 */
export function getOrderLocaleLanguage(language: string): OrderLocaleLanguage {
  const localeMap: Record<string, OrderLocaleLanguage> = {
    en: OrderLocaleLanguage.English,
    ja: OrderLocaleLanguage.Japanese,
    ko: OrderLocaleLanguage.Korean,
    zh: OrderLocaleLanguage.Chinese,
    zt: OrderLocaleLanguage.Chinese
  };

  return localeMap[language] || OrderLocaleLanguage.Chinese;
}
